module.exports = __webpack_public_path__ + "img/different.0c1e657d.png";